import { SearchReasult } from "@src/widgets/SearchResult/ui/SearchResult";

import styles from "./styles.module.scss";

export const SearchHistory = () => {
  return (
    <div className={styles.searchHistoryWrap}>
      <div className={styles.title}>Результаты подбора на ваши вакансии</div>
      <div className={styles.content}>
        <div className={styles.searcHistoryResults}>
          <div className={styles.searchResult}>
            <SearchReasult />
          </div>
        </div>
        <div className={styles.rightInfoBar}></div>
      </div>
    </div>
  );
};
